"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryStack", {
  enumerable: true,
  get: function () {
    return _victoryStack.default;
  }
});

var _victoryStack = _interopRequireDefault(require("./victory-stack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-stack/lib/index.js
// module id = 1903
// module chunks = 0